import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../../../../common/ObjectStructures/Trasnversal';
import { useBoolean } from '@fluentui/react-hooks';
import List from '../../../../../Templates/List';
import ListPagination from '../../../../../Templates/List/ListPagination';
import { Col, Row } from 'react-bootstrap';
import { useGetListGapAnalyzeComments } from '../../../../../../hooks/services/sKPI/useOfGAP';
import { __GapEventTypes, __MessageTypes } from '../../../../../../common/Dictionaries';
import PropTypes from 'prop-types';
import CTextArea from '../../../../../Common/CTextArea';
import { addGapComment } from '../../../../../../services/sKPI/gap.service';
import CLabel from '../../../../../Common/CLabel';
import moment from 'moment';
import DOMPurify from 'dompurify';
import MessageBox from '../../../../../Common/Message/MessageBox';
import { showMessage } from '../../../../../../common/Helpers';


const SidePanelGapDataserieComments = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_GapId = null,
        inputParam_GapAnalyzeId = null,
        inputParam_EditMode = null,
        inputParam_DataserieName = null,
        inputParam_DataserieValue = null,
        inputParam_DataserieValueId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
    } = props;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [objComment, setObjComment] = useState(null);
    const [txtCommentIsInValid, setTxtCommentIsInValid] = useState(null);
    
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [itemToDelete, setItemToDelete] = useState(null);

    const [commentList, setCommentList] = useState(__OBJECT_STRUCTURE_GetList());
    useGetListGapAnalyzeComments(inputParam_GapAnalyzeId, null, null, null, inputParam_DataserieValueId, __GapEventTypes.GAP_DATASERIEVALUE_COMMENTS, commentList, setCommentList, inputParam_IsPanelOpen)

    const validateForm = (objComment) => {
        const validComment = objComment !== "";

        setTxtCommentIsInValid(!validComment)

        return validComment;
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)
        setCommentList(__OBJECT_STRUCTURE_GetList())
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onAddCommentsToBox = () => {
        const _isValidForm = validateForm(objComment);

        if (_isValidForm) {
            addGapComment(inputParam_GapAnalyzeId, null, null, null, inputParam_DataserieValueId, objComment, __GapEventTypes.GAP_DATASERIEVALUE_COMMENTS).then((response) => {
                if (response.data.succeeded) {                  
                    setCommentList(prevState => ({
                        ...prevState,
                        data: null,
                        fireUpdate: true
                    }));
    
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onDeleteSectionFromListClick = (item, setItemToDelete) => {
        setItemToDelete(item);
    };

    const onRenderFooterContent = () => {
        return <div className='jojo'>
            <Row>
                <Col>
                    <ListPagination
                        listLocalStoragePageSizeVariableName="dataserieCommentList"
                        data={ commentList }
                        setData={ setCommentList } />
                </Col>
            </Row>
            <Row>
                <Col>
                    <MessageBox  
                        inputParam_Width="96%" 
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                </Col>
            </Row>
        </div>
    }

    //#CUSTOMDELETE#
    if (itemToDelete !== null) {
        let newList = [];

        commentList.data.forEach(obj => {
            if (obj.comment !== itemToDelete.comment) {
                newList.push(obj)
            }
        })

        setCommentList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: newList
        }));

        setItemToDelete(null);
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-kpivaluecommitments') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    inputParam_EditMode &&
                    <>
                        <Row className="pt-3">
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-name') }
                                    labelValue ={ inputParam_DataserieName }
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <CLabel
                                    labelText={ t('data-lang-lbl-period') }
                                    labelValue ={ inputParam_DataserieValue.serieTime }
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <CTextArea
                                    labelText={ t('data-lang-lbl-comment') }
                                    controlValue={ objComment }
                                    setterControlValue={ setObjComment }
                                    isInvalirControl={ txtCommentIsInValid }
                                    hideToolbar={ true }
                                    maxLength={250}
                                />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <PrimaryButton onClick={ onAddCommentsToBox } styles={ _global_buttonStyles }>{ t('data-lang-btn-add') }</PrimaryButton>
                            </Col>
                        </Row>
                </>
                }
                <Row className="pt-3">
                    <Col>
                        <List
                            listLocalStoragePageSizeVariableName="revisionCommentList"
                            className="no-compact-list"
                            manipulateLocalData={ true }
                            setData={setCommentList}
                            showHeaders={false}
                            data={commentList}
                            columns={[
                                {
                                    key: 'comment',
                                    name: t('data-lang-lbl-comment'),
                                    fieldName: 'comment',
                                    onRender:(item) => {
                                        return  <Row className='py-2'>
                                                    <Col xl={12}>
                                                        <Row>
                                                            <Col xl={6}>
                                                                <CLabel labelText={t('data-lang-lbl-user')} labelValue={ item.gapEventUsername } />
                                                            </Col>
                                                            <Col className='col-auto'>
                                                                <CLabel labelText={t('data-lang-lbl-date')} labelValue={ moment(item.gapEventDate).format("DD/MM/YYYY") } />
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xl={12}>
                                                        <CLabel labelText={t('data-lang-lbl-comment')} className={"labelwrap"} />
                                                    </Col>
                                                    <Col xl={12}>
                                                        <div className='border p-2' style={{textWrap: 'auto'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.gapEventComment, { USE_PROFILES: { html: true } }) }} />
                                                    </Col>
                                                </Row>
                                    }
                                }
                            ]}
                        />
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelGapDataserieComments.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapRevisionId: PropTypes.number.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_SetterChangedEntityProps: PropTypes.func.isRequired,
};

export default SidePanelGapDataserieComments;